import React, { useState } from "react";
import { Card, CardBody, CardFooter, CardHeader, Spacer, Divider, Image, Input, Button, Form, Alert } from "@heroui/react";
import {ArrowLeft} from "lucide-react";
import {motion, AnimatePresence} from "framer-motion";
import {apiClientExporter} from "../../services/apiClient";

function ExporterLogin({ onLoginSuccess }) { // Added a prop to notify the controller
    const [password, setPassword] = useState("");
    const [email, setEmail] = useState("");
    const [userExists, setUserExists] = useState(undefined);
    const [registeredStatus, setRegisteredStatus] = useState(false);
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [userData, setUserData] = useState({});

    //deprecated
    const logIn = async (e) => {
        e.preventDefault();
        setError("");
        setIsLoading(true);

        const credentials = btoa(`${email}:${password}`);

        try {
            const response = await apiClientExporter.post(`/auth/exporter_log_in`, {}, {
                headers: {
                    "Authorization": `Basic ${credentials}`,
                },
            });
            if(response.status === 202) {
                throw new Error(response.data.error);
            } else if (response.status !== 200) {
                throw new Error("Invalid credentials or server error");
            }

            const authToken = response.headers.get("auth-token");
            if (!authToken) {
                throw new Error("Token not found in headers");
            }

            const data = await response.data;
            // console.log("Login successful (exporter):", authToken);
            localStorage.setItem("exporterAuthToken", authToken);
            if (onLoginSuccess) onLoginSuccess(); // Notify the controller
        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    const signUp = async (e) => {
        e.preventDefault();
        setError("");
        setIsLoading(true);

        const userDetails = {
            email: email,
            password: password,
            firstName: firstName,
            lastName: lastName,
        }

        try {
            const response = await apiClientExporter.post(`/auth/exporter_sign_up`, userDetails);

            console.log("response", response);

            if(response.status === 202){
                throw new Error(response.data.error);
            } else if (response.status === 201) {

                setRegisteredStatus(true);
                //TODO: bloquear inputs

            } else if (response.status !== 200) {
                throw new Error("Invalid credentials or server error");
            }

            // const authToken = response.headers.get("auth-token");
            // if (!authToken) {
            //     throw new Error("Token not found in headers");
            // }
            //
            // const data = await response.data;
            // // console.log("Login successful (exporter):", authToken);
            // localStorage.setItem("exporterAuthToken", authToken);
            // if (onLoginSuccess) onLoginSuccess(); // Notify the controller
        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    const check_user_with_email_exists = async (e) => {
        e.preventDefault();
        setError("");
        setIsLoading(true);

        try {
            const response = await apiClientExporter.post(`/auth/check_user_with_email_exists`,
                {
                    "email":`${email}`
                }, {
                headers: {
                    "Content-Type": "application/json"
                },
            });

            if(response.status === 202){
                throw new Error(response.data.error);
            } else if (response.status !== 200) {
                throw new Error("Invalid credentials or server error");
            }

            const userExists = response.data.exists;
            if (userExists === false) {
                console.log("userExists", response.data);
                setUserExists(false);
                if(response.data.results !== undefined) {
                    setUserData(response.data.results[0]);
                }

                return;
            }

            setUserExists(true);

            console.log(response.data.results)

            if(response.data.results !== undefined) {
                setUserData(response.data.results[0]);
            }

            console.log("userExists", response.data);
        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleGoBack = () => {
        setUserExists(undefined);
        setError(null);
        setRegisteredStatus(false);
        setFirstName("");
        setLastName("");
        setPassword("");
        setUserData({});
    }

    const handleSubmit = async (e) => {

        if(userExists === undefined) {
            check_user_with_email_exists(e)
            console.log("check if user exists")
        } else if (userExists) {
            console.log("Log in")
            logIn(e) //old, deprecated
        } else {
            setRegisteredStatus(false);
            signUp(e)
            console.log("sign up")
        }

    }

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
                backgroundColor: "#f5f5f5",
            }}
        >
            <Card className="max-w-[400px] flex justify-center items-center">
                <CardHeader>
                    <Image
                        alt="QuickView logo"
                        height={40}
                        radius="sm"
                        src={process.env.PUBLIC_URL + "/QuickViewR.png"}
                        width={270}
                    />
                    <Image
                        src= {process.env.PUBLIC_URL + "/PoweredBy.png"}
                        className="max-w-[70px] max-h-[40px] object-contain"
                        width={70}
                        height={40}
                        alt="AWS Logo"
                    />
                </CardHeader>
                <Divider />
                <Form validationBehavior="native" onSubmit={handleSubmit}>
                    <CardBody>
                        <AnimatePresence mode="wait">
                            {isLoading ? (
                                <motion.div
                                    key="loading"
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -20 }}
                                    transition={{ duration: 0.3 }}
                                >
                                    <div className="flex justify-center items-center">
                                        <p>Loading...</p>
                                    </div>
                                </motion.div>
                            ) : userExists === undefined ? (
                                <motion.div
                                    key="email"
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -20 }}
                                    transition={{ duration: 0.3 }}
                                >
                                    <div className="flex justify-center items-center">
                                        <p className="text-2xl">Sign up or log in</p>
                                    </div>
                                    <Spacer className="h-3" />
                                    <Input
                                        isRequired
                                        className="max-w-xs"
                                        label="Exporter Email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </motion.div>
                            ) : userExists ? (
                                <motion.div
                                    key="password"
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -20 }}
                                    transition={{ duration: 0.3 }}
                                >
                                    <Button
                                        onPress={() => handleGoBack()}
                                        size="sm"
                                    >
                                        <ArrowLeft /> Back
                                    </Button>
                                    <Spacer className="h-3" />
                                    <div className="flex flex-col justify-center items-center">
                                        <p className="text-2xl">Welcome back</p>
                                        {userData.logo && (
                                            <Image
                                                src={userData.logo}
                                                alt="Exporter Logo"
                                                className="max-w-[70px] max-h-[40px] object-contain"
                                                width={70}
                                                height={40}
                                            />
                                        )}
                                    </div>
                                    <Spacer className="h-3" />
                                    <h4>Log in using {email}</h4>
                                    <Spacer className="h-3" />
                                    <Input
                                        isRequired
                                        className="max-w-xs"
                                        label="Password"
                                        type="password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                </motion.div>
                            ) : (
                                <motion.div
                                    key="signup"
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -20 }}
                                    transition={{ duration: 0.3 }}
                                >
                                    <div className="justify-start">
                                        {!registeredStatus && (
                                            <Button
                                                onPress={() => handleGoBack()}
                                                size="sm"
                                            >
                                                <ArrowLeft /> Back
                                            </Button>
                                        )}
                                    </div>
                                    <Spacer className="h-3" />
                                    <div className="flex col justify-center items-center">
                                        <p>Sign up as {email}</p>
                                    </div>
                                    {userData.logo && (
                                        <div className="flex col justify-center items-center">
                                            <Image
                                                src={userData.logo}
                                                alt="Exporter Logo"
                                                className="max-w-[70px] max-h-[40px] object-contain"
                                                width={70}
                                                height={40}
                                            />
                                        </div>
                                    )}
                                    <Spacer className="h-3" />
                                    <div className="flex flex-col gap-3 max-w-xs">
                                        <Input
                                            readOnly={registeredStatus}
                                            isRequired
                                            label="First Name"
                                            value={firstName}
                                            onChange={(e) => setFirstName(e.target.value)}
                                        />
                                        <Input
                                            readOnly={registeredStatus}
                                            isRequired
                                            label="Last Name"
                                            value={lastName}
                                            onChange={(e) => setLastName(e.target.value)}
                                        />
                                        <Input
                                            readOnly={registeredStatus}
                                            isRequired
                                            label="Password"
                                            type="password"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                        />
                                    </div>
                                    {registeredStatus && (
                                        <div className="flex flex-col gap-3 max-w-xs">
                                            <Spacer className="h-3" />
                                            <Alert hideIcon color="success" description="Please check your inbox to activate your account." title="Account created successfully!" variant="faded" />
                                        </div>
                                    )}
                                </motion.div>
                            )}
                        </AnimatePresence>
                        <Spacer className="h-3" />
                        <div className="flex justify-center">
                            {error && <Alert hideIcon className="max-w-[250px]" color="danger">{error}</Alert>}
                        </div>
                    </CardBody>
                    <Divider />
                    <CardFooter className="justify-end">
                        {registeredStatus ? (
                            <Button
                                onPress={() => handleGoBack()}
                            >
                                <ArrowLeft /> Go Back to login
                            </Button>
                        ) : (
                            <Button color="primary" type="submit" disabled={isLoading}>
                                {isLoading ? "Processing..." :
                                    userExists === undefined ? "Continue" :
                                        userExists ? "Log in" : "Sign up"}
                            </Button>
                        )}
                    </CardFooter>
                </Form>
            </Card>
        </div>
    );
}

export default ExporterLogin;